import React from 'react';
import { Row, Col, Card, Progress } from 'design-system';

// 统计卡片数据项接口
export interface StatisticCardItem {
  label: string;
  value: number;
  color: string;
  type: 'number' | 'progress';
}

// 统计卡片组件属性接口
export interface StatisticsCardsProps {
  title: string;
  totalValue: number;
  items: StatisticCardItem[];
  style?: React.CSSProperties;
  cardHeight?: number;
}

// 统计卡片组件
const StatisticsCards: React.FC<StatisticsCardsProps> = ({
  title,
  totalValue,
  items,
  style,
  cardHeight = 163,
}) => {
  const spanSize = Math.floor(24 / (items.length + 1)); // +1 for the total card

  return (
    <div style={{ marginBottom: 16, ...style }}>
      <Row gutter={16}>
        {/* 总数卡片 */}
        <Col span={spanSize}>
          <Card
            style={{
              borderRadius: 8,
              minHeight: cardHeight,
              height: cardHeight,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderColor: '#fff',
            }}
          >
            <div style={{ width: '100%', textAlign: 'left', marginBottom: 8 }}>
              <span
                style={{
                  borderLeft: '4px solid #105fc8',
                  paddingLeft: 8,
                  fontWeight: 500,
                  fontSize: 15,
                }}
              >
                {title}
              </span>
            </div>
            <div
              style={{
                fontSize: 40,
                fontWeight: 600,
                color: '#222',
                width: '100%',
                textAlign: 'left',
                paddingLeft: 12,
              }}
            >
              {totalValue}
            </div>
          </Card>
        </Col>

        {/* 统计项卡片 */}
        {items.map((item, index) => (
          <Col key={index} span={spanSize}>
            <Card
              style={{
                borderRadius: 8,
                minHeight: cardHeight,
                height: cardHeight,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderColor: '#fff',
              }}
            >
              {item.type === 'progress' ? (
                <Progress
                  type="dashboard"
                  percent={
                    totalValue
                      ? Math.round((item.value / totalValue) * 100)
                      : 0
                  }
                  strokeColor={item.color}
                  width={140}
                  strokeWidth={12}
                  format={() => (
                    <div
                      style={{
                        color: item.color,
                        fontWeight: 600,
                        fontSize: 28,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <div>{item.value}</div>
                      <div
                        style={{
                          fontSize: 14,
                          color: '#525866',
                          fontWeight: 500,
                          marginTop: 2,
                        }}
                      >
                        {item.label}
                      </div>
                    </div>
                  )}
                />
              ) : (
                <>
                  <div style={{ width: '100%', textAlign: 'left', marginBottom: 8 }}>
                    <span
                      style={{
                        borderLeft: `4px solid ${item.color}`,
                        paddingLeft: 8,
                        fontWeight: 500,
                        fontSize: 15,
                      }}
                    >
                      {item.label}
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: 40,
                      fontWeight: 600,
                      color: '#222',
                      width: '100%',
                      textAlign: 'left',
                      paddingLeft: 12,
                    }}
                  >
                    {item.value}
                  </div>
                </>
              )}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default StatisticsCards;